



















































































import Vue from 'vue'

import { Component, Prop, Watch } from 'vue-property-decorator'
import { required } from '@/utils/formValidations'
import {
  greaterOrEquals,
  lessOrEquals,
  maxLength,
  totalLength,
  email,
} from '@/utils/ValidationUtil'
import Configuracion from '@/model/Configuracion'
import FrecuenciaNotificaciones from './FrecuenciaNotificaciones.vue'

@Component({
  components: { FrecuenciaNotificaciones },
})
export default class FormConfiguraciones extends Vue {
  $refs: {
    form: Vue & { validate(): boolean; resetValidation(): void; reset(): void }
  }

  @Prop({ default: true })
  private showAgregar: boolean

  @Prop({ default: false, type: Boolean })
  private disabled: boolean

  @Prop({ required: true })
  private configuracion!: Configuracion

  @Prop({ default: false, type: Boolean })
  private loading = false

  @Prop({ type: String })
  private errorMessage

  @Prop({ default: false, type: Boolean })
  private error = false

  private localInstance: Configuracion = this.configuracion

  private formDisabled = false

  private autoGrow = false

  private dialog = false

  private valid = true

  private rules = {
    required,
    email,
    maxLength500: maxLength(500),
    length4: totalLength(4),
    greaterOrEquals2021: greaterOrEquals((): number => 2021),
    maxLength6: maxLength(6),
    lessOrEquals: lessOrEquals(this.calcularMax.bind(this)),
  }
  calcularMax(): number | undefined {
    return new Date().getUTCFullYear()
  }
  private show = true

  private async newInstance() {
    await this.$emit('newInstance')
    await this.resetValidation()
    await this.$nextTick(this.openDialog)
  }

  resetValidation() {
    this.$refs.form.resetValidation()
  }
  reset() {
    this.$refs.form.reset()
  }
  dias(value) {
    if (!value || value === '') return true
    return (value >= 1 && value <= 90) || 'Debe encontrarse entre 1 y 90 días'
  }

  onClose() {
    this.dialog = false
    this.$nextTick(this.reset)
  }

  async openDialog() {
    await this.onEntidadChange()
  }

  validate() {
    return this.$refs.form.validate()
  }

  onSave() {
    if (this.validate()) {
      this.$emit('save', this.localInstance)
    }
  }

  @Watch('configuracion')
  private onEntidadChange() {
    if (this.configuracion) {
      this.localInstance = JSON.parse(JSON.stringify(this.configuracion))
    }
  }
}
